import { render, staticRenderFns } from "./footballMatch.vue?vue&type=template&id=4e8f4da6&scoped=true&"
import script from "./footballMatch.vue?vue&type=script&lang=js&"
export * from "./footballMatch.vue?vue&type=script&lang=js&"
import style0 from "./footballMatch.vue?vue&type=style&index=0&id=4e8f4da6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f4da6",
  null
  
)

export default component.exports